import styles from "../AudioRecorder.module.scss";
import { ReactComponent as OutlineMicrophoneMuted } from "assets/svg/outline-microphone-muted.svg";
import { ReactComponent as OutlineMicrophone } from "assets/svg/outline-microphone.svg";
import { ReactComponent as IconSessions } from "assets/svg/video-chat/icon-sessions.svg";
import { ReactComponent as CallEnd } from "assets/svg/call-end.svg";
import { ReactComponent as OutlineCalendarPlus } from "assets/svg/outline-calendar-plus.svg";
import { ReactComponent as UpArrow } from "assets/svg/outline-chevron-up-video.svg";
import ControlButton from "components/video-chat/components/control-button/ControlButton";
import IconButton from "components/icon-button";
import AudioInputLevel from "components/video-chat/select-devices/AudioInputLevel";
import { useState } from "react";
import MicOptions from "./MicOptions";
import { isMobileOnly, isTablet } from "react-device-detect";

const AudioRecorderControlPanel = ({
  appointment,
  currentTime,
  isPaused,
  mediaRecorderRef,
  setIsPaused,
  setShowScheduleModal,
  isRecordingStarted,
  isRecordingFinished,
  setShowNotesPanel,
  setShowConfirmEndModal,
  micMediaStreamRef,
  hasMicroPhoneAccess,
  onAudioInputChange,
}) => {
  const [showSoundSetting, setShowSoundSetting] = useState(false);
  const audioInputDeviceId = micMediaStreamRef?.current
    ?.getAudioTracks()[0]
    ?.getSettings()?.deviceId;
  const toggleSoundSetting = () => {
    setShowSoundSetting((prev) => !prev);
  };
  const isWeb = !isMobileOnly && !isTablet;
  return (
    <div className={styles["audio-recorder__footer"]}>
      <div className={styles["audio-recorder__footer-section"]}>
        <div className={styles["audio-recorder__clock"]}>{currentTime}</div>
      </div>
      <div className={styles["audio-recorder__footer-section"]}>
        <div
          className={
            isWeb ? styles["audio-recorder__microphone-container"] : ""
          }
        >
          <ControlButton
            className={styles["audio-recorder__mute-button"]}
            title={isPaused ? "Unmute Audio" : "Mute Audio"}
            onClick={() => {
              if (!mediaRecorderRef.current) {
                return;
              }
              if (isPaused) {
                mediaRecorderRef.current.resume();
                setIsPaused(false);
              } else {
                mediaRecorderRef.current.pause();
                setIsPaused(true);
              }
            }}
          >
            {isPaused ? <OutlineMicrophoneMuted /> : <OutlineMicrophone />}
            <AudioInputLevel
              mediaStreamTrack={micMediaStreamRef?.current?.getTracks()[0]}
            />
          </ControlButton>
          {isWeb && (
            <>
              <IconButton onClick={toggleSoundSetting}>
                <UpArrow />
              </IconButton>
              {showSoundSetting && (
                <MicOptions
                  micMediaStreamRef={micMediaStreamRef}
                  audioInputDeviceId={audioInputDeviceId}
                  hasMediaAccess={hasMicroPhoneAccess}
                  onAudioInputChange={onAudioInputChange}
                />
              )}
            </>
          )}
        </div>

        <ControlButton
          onClick={() => {
            setShowNotesPanel((prev) => !prev);
          }}
        >
          <IconSessions />
        </ControlButton>

        <ControlButton
          className={styles["audio-recorder__end-button"]}
          title="End Session"
          onClick={() => {
            setShowConfirmEndModal(true);
          }}
          disabled={!isRecordingStarted || isRecordingFinished}
        >
          <CallEnd />
        </ControlButton>
      </div>
      <div className={styles["audio-recorder__footer-section"]}>
        {appointment?.session_recording_type !== "dictation" && (
          <IconButton onClick={() => setShowScheduleModal(true)}>
            <OutlineCalendarPlus />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default AudioRecorderControlPanel;
